import React from 'react';

import { Block, Typography } from '@atoms';
import { getEntityActionsInfo } from '@utils';
import { formatGracefully as formatDate } from '@utils/date';

import s from './styles.module.less';

const entityNameOptions = {
  keys: { modified: 'modified' },
  names: { modified: 'Modified' },
  weights: {
    created: 1,
    modified: 2,
    published: 3,
  },
};

const ActionsInfoBlock = ({ entity }) => {
  const actionsInfo = getEntityActionsInfo(entity, entityNameOptions);

  return (
    <Block spaced>
      {!actionsInfo?.length && <Typography.Text className={s.text}>Not created yet</Typography.Text>}
      {actionsInfo?.map(({ action, date, user }, index) => (
        <Typography.Text className={s.text} key={index}>
          <b>{action}</b>{' '}
          <time dateTime={date} title={date}>
            {formatDate(date)}
          </time>{' '}
          by {user}
        </Typography.Text>
      ))}
    </Block>
  );
};

export default ActionsInfoBlock;
